import request from '@/utils/request'

let AdApi = {
  /*列表*/
   adList(data) {
    return request._post('/shop/plus.ad.ad/index', data);
  },
  /*添加*/
  addAd(data) {
    return request._post('/shop/plus.ad.ad/add', data);
  },
  /*获取数据*/
  getAd(data) {
    return request._get('/shop/plus.ad.ad/edit', data);
  },
  /*保存*/
  saveAd(data) {
    console.log(data)
    return request._post('/shop/plus.ad.ad/edit', data);
  },
  /*删除*/
  delAd(data) {
    return request._post('/shop/plus.ad.ad/delete', data);
  },

}
export default AdApi;



// WEBPACK FOOTER //
// ./src/api/ad.js